<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top-off" style="background-color: #ffffff">
	<!--                      -->
	<!-- Set Student Language -->
	<!--                      -->
	<div class="LanguageDiv" *ngIf="IsNotificationsForSchoolEnabled == true || IsStudentSchoolNotificationEnabled == true">
		<div class="LanguageGrid">
			<label class="NoMargin">CAASS Notify Language:</label>

			<select [disabled]="isBusy == true" class="form-control NoMargin" name="SelectedNotifyLanguageID" [(ngModel)]="SelectedNotifyLanguageID">
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstNotifyLanguages" [ngValue]="o.NotifyLanguageID">
					{{ o.NotifyLanguageDesc }}
				</option>
			</select>

			<label class="NoMargin" style="color: orangered"
				>(Note: this doesn't apply to custom messages sent from this screen or the NEW Parent Portal App)</label
			>

			<button [disabled]="isBusy == true" class="btn btn-primary" (click)="onUpdateLanguage()">Update Language</button>
		</div>
	</div>

	<!-- 	            -->
	<!-- Notify Message -->
	<!-- 	       		-->
	<div class="button-body">
		<div>
			<label class="column-item-label">Message</label>
		</div>

		<div style="margin-left: 10px; width: 100%">
			<input
				type="text"
				pInputText
				[(ngModel)]="NotificationMessage"
				style="width: 100%"
				[disabled]="isBusy == true || IsNotificationsForSchoolEnabled == false || IsStudentSchoolNotificationEnabled == false"
			/>
		</div>
	</div>

	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div class="button-body">
		<button
			class="btn btn-primary"
			style="margin-left: 0px"
			(click)="onSend()"
			[disabled]="isBusy == true || IsNotificationsForSchoolEnabled == false || IsStudentSchoolNotificationEnabled == false"
		>
			Send Notification
		</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Notifications are sent using CAASS Notify and the NEW Parent Portal App.</label><br />
		<label>&#9900; Guardians will receive the message on a registered IOS or Android Device.</label><br />
		<label
			>&#9900; To register for the Parent Portal App go to either Students/Parent Portal Registration or School Settings/Portal App Batch
			Registration.</label
		><br />
		<label>&#9900; Generate Registration QR Codes and send them to the guardians for their student(s).</label><br />
		<label>&#9900; Guardians will need to download the CAASS Parent Portal App from the App Store (IOS) or Google Play Store (Android).</label><br />
		<label>&#9900; When the app starts up guardians will have to make an account and scan their QR code.</label><br />
		<br />
		<br />
		<label>&#9900; If you are still using CAASS Notify: you will need to generate registration keys and send them to the guardians.</label><br />
		<label>&#9900; Guardians need to download CAASSNotify from the App Store (IOS) or Google Play Store (Android)</label><br />
		<label>&#9900; Guardians need to create an account and enter the registration key that was sent to them in an e-mail.</label><br />
		<label>&#9900; Guardians will need to make sure they have enabled School Notifications in CAASSNotify.</label><br />
	</div>
</div>

<!-- 		  -->
<!-- Messages -->
<!-- 		  -->
<div style="margin-top: 10px">
	<div [style.display]="SuccessMessage != '' ? 'block' : 'none'">
		<div style="margin: 2px" class="alert alert-success">
			{{ SuccessMessage }}
		</div>
	</div>

	<div [style.display]="WarningMessage != '' ? 'block' : 'none'">
		<div style="margin: 2px" class="alert alert-warning">
			{{ WarningMessage }}
		</div>
	</div>

	<div [style.display]="ErrorMessage != '' ? 'block' : 'none'">
		<div style="margin: 2px" class="alert alert-danger">
			{{ ErrorMessage }}
		</div>
	</div>
</div>
